const ReturnActionNamesEnum = {
  Restock: 'Restock',
  Dispose: 'Dispose',
  Quarantine: 'Quarantine'
}

export default ReturnActionNamesEnum

export const ReturnActionsEnum = {
  Restock: 1,
  Quarantine: 2,
  Dispose: 3
}

export const ReturnActionsMappingEnum = {
  [ReturnActionsEnum.Restock]: ReturnActionNamesEnum.Restock,
  [ReturnActionsEnum.Quarantine]: ReturnActionNamesEnum.Quarantine,
  [ReturnActionsEnum.Dispose]: ReturnActionNamesEnum.Dispose
}
